__turbopack_context__.v({
  "heartbeat": "LikeEventButton-module-scss-module__vBfIrG__heartbeat",
  "likeButton": "LikeEventButton-module-scss-module__vBfIrG__likeButton",
  "likeButtonContainer": "LikeEventButton-module-scss-module__vBfIrG__likeButtonContainer",
  "liked": "LikeEventButton-module-scss-module__vBfIrG__liked",
});
